import { Component, Input } from '@angular/core';
import { Payment } from '../../models/paymentmodel';
import { SharedService }   from '../../services/sharedservices.service';
import { Session } from '../../models/sessionmodel';
import { PaymentResponse } from '../../models/responsemodel';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import {Router} from  '@angular/router';


@Component({
  templateUrl: './dashboard.component.html',
  styleUrls: ['../../css/sb-admin.min.css'],
  providers: []
})

export class DashboardComponent {
 public session: Session;
  payment: Payment;
  errorMessage: string;

  constructor(public router: Router, public sharedservice: SharedService) {}

  ngOnInit()
  {
      
      /*if (this.sharedservice.session != null)
      {
        this.session = this.sharedservice.session;
        if (this.sharedservice.session.account_status == "1")
          this.router.navigate(['mca']);
        if(this.sharedservice.session.account_role == "admin"){
          this.isAdmin = true;
        }
      }*/          
      
  }

  logout(){
    this.sharedservice.logout();
  }

  /*login(isValid: boolean){
    if(isValid){
      this._PaymentService.makePayment(this.payment).subscribe(res => this.handleResponse(res), error => this.errorMessage = <any>error);
    }
  }*/

  handleResponse(result){
   
  }


}



// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/app/dashboard/dashboard.component.ts